import { PrimaryColor } from '../shared/constants';
import { PRIMARY_COLOR_MAP } from '../shared/primary-color-map';

type BasePalette = Record<string, unknown>;

export function mergePrimaryIntoPalette(
  basePalette: BasePalette,
  primaryColor: PrimaryColor,
  isDark: boolean,
): BasePalette {
  const c = PRIMARY_COLOR_MAP[primaryColor];
  const primaryTransparent = isDark ? c.transparentDark : c.transparentLight;
  const menuSecondary = isDark ? c.menuSecondary.dark : c.menuSecondary.light;
  const menuSecondaryDark = isDark
    ? c.menuSecondaryDark.dark
    : c.menuSecondaryDark.light;
  const footerBackgroundActive = isDark
    ? c.footerBackgroundActive.dark
    : c.footerBackgroundActive.light;

  return {
    ...basePalette,
    primary: {
      ...(basePalette.primary as object),
      main: c.main,
      dark: c.dark,
      light: c.light,
      contrastText: c.contrastText,
    },
    primaryTransparent,
    primaryGradient: c.gradient,
    primarySamitransparent: c.semitransparent,
    menu: {
      ...(basePalette.menu as object),
      secondary: menuSecondary,
      secondaryDark: menuSecondaryDark,
      secondaryContrastText: c.main,
    },
    tabControl: {
      ...(basePalette.tabControl as object),
      secondary: c.main,
      secondaryDark: c.dark,
      secondaryContrastText: c.contrastText,
    },
    paper: {
      ...(basePalette.paper as object),
      hoverBorderColor: c.main,
    },
    custom: {
      ...(basePalette.custom as object),
      linkColor: c.main,
    },
    footer: {
      ...(basePalette.footer as object),
      activeColor: c.main,
      backgroundActiveColor: footerBackgroundActive,
    },
  };
}
